export default __webpack_public_path__ + "static/media/musisi_berkualitas.a0c28a4b.svg";